module.exports = __webpack_public_path__ + "static/media/TubeStandSMWide.8217a2d4.svg";